// B-HPTHANKYOU: a sikeres jelentkezés utáni köszönő oldal útvonalának determinisztikus
// feloldása a config.pages-ből. Korábban a JobDetailView/CvuploadView külön-külön a
// find(module==='thankyou') ELSŐ találatával dolgozott — ha egy ügyfélnél (pl. HP)
// sima kulcsú ÉS '(.*?)' placeholderes thankyou page is van, a sorrend döntött, és a
// job-specifikus contact blokk (ami csak job_id-s URL-nél jön) elveszhetett.
//
// Szabályok:
//   - A több '(.*?)' placeholderes kulcsok érvénytelenek (a router sem támogatja) — ignorálva.
//   - jobId > 0: az egy-placeholderes kulcs preferált (job_id behelyettesítve), fallback a sima kulcs.
//   - jobId nincs/0 (spontán jelentkezés): a sima kulcs preferált, fallback az
//     egy-placeholderes '0'-val (a korábbi CvuploadView viselkedés megtartása).
//   - Nincs használható thankyou page: null — a hívó a főoldalra navigál.
const PLACEHOLDER = '(.*?)';
function placeholderCount(key) {
    return (key.match(/\(\.\*\?\)/g) || []).length;
}
export function resolveThankyouPath(pages, slug, jobId) {
    const candidates = (pages || []).filter(p => p.module === 'thankyou' && placeholderCount(p.key) <= 1);
    const withPlaceholder = candidates.find(p => placeholderCount(p.key) === 1);
    const plain = candidates.find(p => placeholderCount(p.key) === 0);
    const hasJob = typeof jobId === 'number' && jobId > 0;
    const chosen = hasJob ? (withPlaceholder || plain) : (plain || withPlaceholder);
    if (!chosen)
        return null;
    const key = placeholderCount(chosen.key) === 1
        ? chosen.key.replace(PLACEHOLDER, hasJob ? String(jobId) : '0')
        : chosen.key;
    return `/${slug}/${key}`;
}
